module.exports = __webpack_public_path__ + "media/images/river/just-fits-66240a9b90d73e46738227de3263046a.webp";